import React from "react";
import PdfViewer from "../../../components/core/PDFviewer/PdfViewer";
import { ReactComponent as DownloadIcon } from "../../../assets/images/download.svg";
import { ReactComponent as ShareIcon } from "../../../assets/images/share.svg";
import { useSelector } from "react-redux";

export interface MediaContainerProps {
  link: string;
  onDownload: (e: any) => void;
  onShare: (e: any) => void;
  isPdf?: boolean;
  isImage?: boolean;
}

const MediaContainer = ({
  link,
  onDownload,
  onShare,
  isPdf,
  isImage,
}: MediaContainerProps) => {
  const { me } = useSelector((state: any) => state.auth);
  const isMobile =
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/iPhone/i);

  return (
    <div className="media-canvas">
      {isPdf ? (
        <PdfViewer
          pdfFile={link}
        />
      ) : isImage ? (
        <img className="media-photo" alt="content" src={link} />
      ) : (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            link
          )}`}
          title="officeFrame"
          width={isMobile ? "100%" : "70%"}
          height={isMobile ? "600px" : "800px"}
          frameBorder="0"
        />
      )}
      <div>
      <button className={`downloadButton downloadFixed ${isPdf ? "sharePdf" : ""}`} onClick={onDownload}>
        <DownloadIcon className="downloadIcon" />
      </button>
      {me && (
        <button className={`downloadButton shareFixed ${isPdf ? "sharePdf" : ""}`} onClick={onShare}>
          <ShareIcon className="shareIcon" />
        </button>
      )}
      </div>
    </div>
  );
};

export default MediaContainer;
